import { createAction, createReducer } from '@reduxjs/toolkit'

const initState: { data: string } = {
  data: '',
};

export const setDataManagementRefresh = createAction<string>('DATA_MANAGEMENT/SET_REFRESH');
export const resetDataManagementRefresh = createAction('DATA_MANAGEMENT/RESET_REFRESH');

export const dataManagementReducer = createReducer(initState, (builder) => {
  builder
    .addCase(setDataManagementRefresh, (state, action) => {
      state.data = action.payload;
    })
    .addCase(resetDataManagementRefresh, (state) => {
      state.data = '';
    })
});
